/*export const SERVER = 'http://inventario.devlancer.site/';
export const API = 'https://web.codesii.com/public/';
export const RESOURCES = 'http://inventario.devlancer.site/';
export const RESOURCESREACT = 'public/assets/';
export const SERVER_EDU_CODESII = 'https://www.edu.codesii.com/';
export const IMAGE = 'http://inventario.devlancer.site/';*/


export const API = 'http://192.168.40.221/ari_pos10/public/';
//export const API = 'http://192.168.1.23/ncpos_system/public/';



